import React, { Component } from 'react';
import { firebaseRef } from './firebase.js';
import { withRouter } from 'react-router-dom';

class Settings extends Component {
constructor(props){
  super(props);
  this.state = {

  };
  this._toggle=this._toggle.bind(this);
}

_toggle(event){
  if(window.confirm("You sure you want to toggle '"+ event.target.title + "' \n Note: You can change this anytime.")){
    var doctor = this.props.match.params.doctor;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/hide/'+event.target.value);
    refMain.once('value', function(datasnapShot){
      if (datasnapShot.exists()) {
        refMain.remove();
      }else{
        refMain.set("true");
        //refMain.set(1);
      }
    });
  }else{
    console.log("no");
  }
}

  render() {
    return (

        <div className="login-signup-container settings">
          <div className="user-name settings-header">
            <h2>What you want to toggle?</h2>
          </div>
            <button type="button" className="user-name settings-button" onClick={this._toggle} value="ocltinex" title="In Ex Oc Lt Rt">In Ex Oc Lt Rt</button>

            <button type="button" className="user-name settings-button" onClick={this._toggle} value="userimage" title="User Image">Profile Image</button>

            <button type="button" className="user-name settings-button" onClick={this._toggle} value="levels" title="Levels">Levels</button>

            <button type="button" className="user-name settings-button" onClick={this._toggle} value="tried" title="Tried of change">Tried of change</button>

            <button type="button" className="user-name settings-button" onClick={this._toggle} value="heel" title="Heel Tension">Heel Tension</button>

            <button type="button" className="user-name settings-button" onClick={this._toggle} value="adbAdd" title="Adb-Add">Adb-Add</button>

            <button type="button" className="user-name settings-button" onClick={this._toggle} value="profile" title="File Image">File Image</button>
        </div>

    );
  }
}

export default withRouter(Settings);



// WEBPACK FOOTER //
// ./src/routes/settings.js